function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_415_59)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5 8H58V56H5V8Z",
  fill: "#D9D9D9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.5 9.5H56.5V54.5H6.5V9.5Z",
  stroke: "black",
  strokeWidth: 3
}));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 9,
  width: 51,
  height: 9,
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 8,
  y: 10,
  width: 47,
  height: 6,
  fill: "#2A32FF"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 13,
  r: 2,
  fill: "#D9D9D9"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 13,
  r: 2,
  fill: "#D9D9D9"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 13,
  r: 2,
  fill: "#D9D9D9"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 31,
  y: 21,
  width: 21,
  height: 19,
  fill: "#26F726"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 34,
  r: 10,
  fill: "#FF7878"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M35 29L47.1244 49.25H22.8756L35 29Z",
  fill: "#2A32FF"
});

var _ref11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_415_59",
  x: 5,
  y: 8,
  width: 56,
  height: 51,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 2,
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_415_59"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_415_59",
  result: "shape"
})));

function SvgApp64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp64);
export default __webpack_public_path__ + "static/media/app_64.c6b7fb9b.svg";
export { ForwardRef as ReactComponent };